import { Brain, MessageSquare, LineChart, Lightbulb } from '../icons';
import { Badge } from '../ui/badge';

const features = [
  {
    icon: Brain,
    title: '24/7 AI Personality Chat',
    description:
      'Talk to our AI companion — day or night — to get real-time insights about your personality traits and growth opportunities.',
    color: 'success',
  },
  {
    icon: MessageSquare,
    title: 'Daily Growth Tracking',
    description:
      'Quick, daily check-ins help you stay aware of your progress and maintain momentum on your personal development journey.',
    color: 'orange',
  },
  {
    icon: Lightbulb,
    title: 'Personalized Insights & Tips',
    description:
      'Receive custom recommendations based on your unique profile to help you develop new skills and overcome challenges.',
    color: 'teal',
  },
  {
    icon: LineChart,
    title: 'Progress Analytics',
    description:
      'Visual dashboards show your growth over time, helping you celebrate wins and identify areas for continued improvement.',
    color: 'brand',
  },
];

export function FeaturesSection() {
  return (
    <section id="about" className="py-20 md:py-28 px-4 md:px-8 bg-brand-5">
      <div className="max-w-[1216px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-1/3">
            <Badge variant="default" className="mb-4">
              Features
            </Badge>
            <h2 className="text-3xl md:text-heading-md font-bold text-brand-90 mb-4">
              Features Designed for Your Growth
            </h2>
            <p className="text-paragraph-lg text-gray-60">
              Explore tools that combine self-discovery and guided reflection to
              build healthier habits and a better mindset.
            </p>
          </div>

          <div className="lg:w-2/3 grid md:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-3xl p-6 border border-gray-20 hover:shadow-soft-lg transition-shadow"
              >
                <div
                  className={`w-12 h-12 rounded-2xl flex items-center justify-center mb-4 ${
                    feature.color === 'success'
                      ? 'bg-success-10'
                      : feature.color === 'orange'
                      ? 'bg-orange-10'
                      : feature.color === 'teal'
                      ? 'bg-teal-10'
                      : 'bg-brand-10'
                  }`}
                >
                  <feature.icon
                    className={`w-6 h-6 ${
                      feature.color === 'success'
                        ? 'text-success-40'
                        : feature.color === 'orange'
                        ? 'text-orange-50'
                        : feature.color === 'teal'
                        ? 'text-teal-50'
                        : 'text-brand-60'
                    }`}
                  />
                </div>
                <h3 className="text-lg font-bold text-gray-80 mb-2">
                  {feature.title}
                </h3>
                <p className="text-paragraph-sm text-gray-60">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
